import useFetchInfinite from 'lib/hooks/useFetchInfinite';

import { Heading, Loader, NavLink } from '@frontendmentorio/design-system-v2';

import CommentCardWithSolution from 'features/comments/CardWithSolution';
import CommentsEmptyState from '../CommentsEmptyState';

export default function Comments({ isCurrentUser, user }) {
  const {
    data: { data: comments },
    isLoading,
  } = useFetchInfinite(
    isCurrentUser
      ? '/api/v3/learner/comments'
      : `/api/v3/learners/${user.id}/comments`
  );

  return (
    <div className="bg-gray-100 px-5 py-7">
      <div className="container-md flex flex-col gap-6 items-center">
        <Heading level="2">Latest comments</Heading>

        {isLoading ? (
          <Loader className="py-12" />
        ) : comments?.length > 0 ? (
          <>
            <ul className="flex flex-col gap-5 w-full">
              {comments.slice(0, 6).map((comment) => (
                <CommentCardWithSolution comment={comment} key={comment.id} />
              ))}
            </ul>

            {comments.length > 6 && (
              <NavLink
                href={`/profile/${user.username}/comments`}
                level="tertiary"
              >
                View more comments
              </NavLink>
            )}
          </>
        ) : (
          <CommentsEmptyState isCurrentUser={isCurrentUser} />
        )}
      </div>
    </div>
  );
}
